
import "./Home.css"

export default function Home() {
    return (
    <div className="welcome-container">
        <h1 className="Milano">Milano's Masonry</h1>
        <h2 className="welcome-text">
        Paramus | New Jersey
        </h2>
        <h3 className="Slogan">Quality in Every Project</h3>
    <div className="welcome-img-container">
    </div>
  </div>
);
}